<template>
  <section class="pt-60 pb-20 overflow-hidden" data-aos="fade-up" :data-aos-delay="200">
    <div class="row y-gap-20 justify-between items-center">
      <div class="col-lg-6">
        <div class="sectionTitle">
          <h2 class="sectionTitle__title">{{ $t('recommendedArticles') }}</h2>
        </div>
      </div>

      <div class="col-auto mb-3">
        <router-link to="/blogs" class="button -icon">
          {{ $t("view_all") }}
        </router-link>
      </div>
    </div>
    <div class="row mt-30">
      <div class="col-lg-4 col-md-6" v-for="blog in spliceArray" :key="blog.id">
        <article-card :blog="blog" />
      </div>
    </div>
  </section>
</template>

<script>
import AOS from "aos";
import ArticleCard from "../common/ArticleCard.vue";
export default {
  components: {
    ArticleCard,
  },
  props: {
    relatedPosts: {
      type: Array
    }
  },
  computed: {
    spliceArray() {
      return Array.isArray(this.relatedPosts)
        ? this.relatedPosts.slice(0, 3)
        : [];
    }
  },
  data() {
    return {};
  },
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
